var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9101 28.991V27.5137C28.9101 26.7301 28.5988 25.9786 28.0447 25.4245C27.4906 24.8704 26.7391 24.5591 25.9555 24.5591H20.0464C19.2628 24.5591 18.5113 24.8704 17.9572 25.4245C17.4031 25.9786 17.0918 26.7301 17.0918 27.5137V28.991M25.9555 18.65C25.9555 20.2818 24.6327 21.6046 23.0009 21.6046C21.3692 21.6046 20.0464 20.2818 20.0464 18.65C20.0464 17.0182 21.3692 15.6954 23.0009 15.6954C24.6327 15.6954 25.9555 17.0182 25.9555 18.65Z",
    stroke: "black",
    strokeOpacity: 0.91,
    strokeWidth: 2.01489,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/auth.887b81898a61d645e1a51713ae8b5484.svg";
export { ForwardRef as ReactComponent };